module.exports = __webpack_public_path__ + "static/media/money.cd3a990b.svg";